import Routes from './Routes';

export default Routes;


// WEBPACK FOOTER //
// ./src/routes/index.js